module.exports = __webpack_public_path__ + "img/packages.352d8c67.jpg";